/**
 * About Screen
 * 
 * About page with legal links (Privacy Policy, Terms of Use) and version info.
 * Matches iOS AboutView.swift implementation.
 * 
 * @module components/menu/AboutScreen
 */

import React from 'react';
import './AboutScreen.css';

interface LinkItemProps {
  title: string;
  url: string;
}

const LinkItem: React.FC<LinkItemProps> = ({ title, url }) => (
  <a 
    href={url} 
    target="_blank" 
    rel="noopener noreferrer"
    className="about-link-item"
  >
    <span className="about-link-title">{title}</span>
    <span className="about-link-arrow">›</span>
  </a>
);

export const AboutScreen: React.FC = () => {
  const links = [
    { title: 'Privacy Policy', url: 'https://www.lore.co/privacypolicy' },
    { title: 'Terms of Use', url: 'https://www.lore.co/terms' },
  ];

  return (
    <div className="about-container">
      {/* Legal Links */}
      <div className="about-links-group">
        {links.map((link) => (
          <LinkItem key={link.title} title={link.title} url={link.url} />
        ))}
      </div>

      {/* Version Info */}
      <div className="about-version">
        <div>Version 1.0.0</div>
        <div>Lore Web Client</div>
        <div className="about-copyright">© 2026 Lore Health</div>
      </div>
    </div>
  );
};
